/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SectionViewAllParams {
  section_id: string;
  screen_name: string;
}

/**
 * 発火タイミング：ExperienceSectionの「もっと見る」ボタンがクリックされた際に発火
 */
export const sendGAWabunkaSectionViewAllEvent = (sectionId: string, screen: string) => {
  sendWabunkaGAEvent('section_view_all', {
    section_id: sectionId,
    screen_name: screen,
  });
};
